import Auth from './auth';
import Banners from './banners';
import Basket from './basket';
import Buttons from './buttons';
import Cashback from './cashback';
import Carousel from './carousel';
import Checkout from './checkout';
import Company from './company';
import Delivery from './delivery';
import Footers from './footers';
import Franchise from './franchise';
import Internet from './internet';
import Loading from './loading';
import LoyaltyProgram from './loyalty-program';
import Marketing from './marketing';
import Menu from './menu';
import Navigation from './navigation';
import OrderType from './order-type';
import Payment from './payment';
import Profile from './profile';
import Rewards from './rewards';
import MetaInfo from './MetaInfo';
import Note from './note';
import Order from './order';
import CookieConsent from './CookieConsent';
import Headers from './headers';
import Labels from './labels';

export default {
  Auth,
  Banners,
  Basket,
  Buttons,
  Carousel,
  Cashback,
  Checkout,
  Company,
  Delivery,
  Footers,
  Franchise,
  Internet,
  Loading,
  LoyaltyProgram,
  Marketing,
  Menu,
  Navigation,
  OrderType,
  Payment,
  Profile,
  Rewards,
  MetaInfo,
  Note,
  Order,
  CookieConsent,
  Headers,
  Labels,
};
